<template>
	<DividerAutoDirection v-if="cleanRecommendedCoords.length > 0">{{ $t('base-stations-edit.fields.recommendedCoords.divider') }}</DividerAutoDirection>
	<Row v-if="cleanRecommendedCoords.length > 0">
		<Col span="24">
			<div class="scrollable-x">
				<Table
					size="small"
					:columns="columns"
					:data-source="cleanRecommendedCoords"
					:pagination="false"
				>
					<template #bodyCell="{ column, record }">
						<template v-if="column.key === 'actions'">
							<PopconfirmButton
								v-if="formsChangedRef"
								type="default"
								size="small"
								:title="$t('base-stations-edit.fields.recommendedCoords.applyConfirmation')"
								:ok-text="$t('base-stations-edit.fields.recommendedCoords.apply')"
								:cancel-text="$t('base-stations-edit.fields.recommendedCoords.cancel')"
								:loading="applyLoading"
								:onConfirm="() => onApply(record.id)"
							>
								{{ $t('base-stations-edit.fields.recommendedCoords.apply') }}
							</PopconfirmButton>
							<Button v-else type="default" size="small" @click="onApply(record.id)" :loading="applyLoading">
								{{ $t('base-stations-edit.fields.recommendedCoords.apply') }}
							</Button>
						</template>
						<template v-else-if="column.dataIndex === 'source'">
							{{ $t('base-stations-edit.fields.recommendedCoords.source.' + record.source) }}
						</template>
					</template>
				</Table>
			</div>
		</Col>
	</Row>
</template>

<script>
import { ref, toRef, computed } from 'vue';

import { useI18n } from 'vue-i18n'

import { Row, Col, Table, Button, message } from 'ant-design-vue';

import Api from '@/api/Api';
import Consts from '@/api/Consts';
import Utils from '@/api/Utils';

import DividerAutoDirection from '@/components/common/DividerAutoDirection.vue';
import PopconfirmButton from '@/components/common/PopconfirmButton.vue';

import { showErrorMessage } from '@/components/common/errorMessage';

export default {
	components: { Row, Col, Table, Button, DividerAutoDirection, PopconfirmButton },
	props: ['baseStationDetails', 'loadBaseStationDetails', 'resetChangedState', 'formsChanged'],
	setup(props) {
		const { t } = useI18n();
		const baseStationDetailsRef = toRef(props, 'baseStationDetails');
		const columns = Consts.recommendedCoordsTableColumnsComp;
		const cleanRecommendedCoords = computed(() => {
			if (
				baseStationDetailsRef.value == null ||
				baseStationDetailsRef.value.recommendedCoords == null ||
				baseStationDetailsRef.value.recommendedCoords.length === 0
			) {
				return [];
			}
			return baseStationDetailsRef.value.recommendedCoords.map(coord => {
				return {
					...coord,
					x_coord: Utils.formatMetres(Utils.mm2m(coord.x_coord)),
					y_coord: Utils.formatMetres(Utils.mm2m(coord.y_coord)),
					z_coord: Utils.formatMetres(Utils.mm2m(coord.z_coord)),
				};
			});
		});
		const applyLoading = ref(false);
		const onApply = recordId => {
			applyLoading.value = true;
			Api.baseStationSetRecommendedCoords(recordId, responseData => {
				applyLoading.value = false;
				if (responseData.status === 'ok') {
					message.success(t('base-stations-edit.fields.recommendedCoords.applySuccess'));
					props.resetChangedState();
					props.loadBaseStationDetails();
				} else {
					showErrorMessage(responseData.errors);
				}
			});
		}
		const formsChangedRef = toRef(props, 'formsChanged');
		return {
			baseStationDetailsRef,
			cleanRecommendedCoords,
			columns,
			applyLoading,
			onApply,
			formsChangedRef,
		}
	}
}
</script>
